import React from 'react'
import Messages from './Messages'
import TopBar from '../components/menu/TopBar'
import Card1 from '../components/Card/Card1'
import { useSelector } from 'react-redux'
import { language } from '../stores/slices/languageSlice'

function Cases() {
    const selectedLanguage = useSelector(language).Cases
    return (
        <div className="content">
            <TopBar />
            <div className="grid columns-12 gap-6">
                <div className="g-col-12 ">
                    <div className="intro-y d-flex flex-column flex-sm-row align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto" data-testid="caseHeading">
                            {selectedLanguage.heading}
                        </h2>
                        <div className="d-lg-flex intro-y">
                            <select className="form-select py-3 px-4 box w-full dark-border-dark-3 w-lg-auto mt-3 mt-lg-0 ms-auto">
                                <option>Sort By</option>
                                <option>A to Z</option>
                                <option>Z to A</option>
                                <option>Lowest Price</option>
                                <option>Highest Price</option>
                            </select>
                        </div>
                    </div>
                    <div className="intro-y tab-content mt-5">
                        <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <div className="grid columns-12 gap-10">
                                <div className="intro-y g-col-12 g-col-lg-6">
                                    <Card1 Program={"Case"} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-6">
                                    <Card1 Program={"Case"} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-6">
                                    <Card1 Program={"Case"} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-6">
                                    <Card1 Program={"Case"} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cases